"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaders = void 0;
var _auth = require("@ori/auth");
var _constants = require("../constants");
var _prepareToken = require("./prepareToken");
/**
 * Utility function for generating core headers for HTTP requests. Returns object with headers.
 * @example
 *
 * const headers = getHeaders({
 *       sourceAppName: 'app',
 *       language: 'cs',
 *       customerId: 1,
 *       tenant: 'cz',
 *       token: 'some-token',
 *     }),
 *
 * useGraphqlQuery({query, url, headers: headers})
 */
const getHeaders = ({
  sourceAppName,
  language,
  customerId,
  tenant,
  token
} = {}) => {
  const headers = {
    [_constants.CONTENT_TYPE]: _constants.JSON_CONTENT
  };
  const formattedToken = (0, _prepareToken.formatToken)(token);
  if (formattedToken) {
    headers[_constants.AUTHORIZATION] = formattedToken;
  }
  if (sourceAppName) {
    headers[_constants.CLIENT_APPLICATION] = sourceAppName;
  }
  if (language) {
    headers[_constants.ACCEPT_LANGUAGE] = language;
  }
  if ((0, _auth.isAuthenticatedCustomer)(customerId)) {
    headers[_constants.CUSTOMER_CONTEXT] = customerId.toString();
  }
  if (tenant) {
    headers[_constants.TENANT_CONTEXT] = tenant;
  }
  return headers;
};
exports.getHeaders = getHeaders;
//# sourceMappingURL=getHeaders.js.map